export default __webpack_public_path__ + "static/media/producers.618576c3.svg";